"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicCategory = void 0;
const class_validator_1 = require("class-validator");
const __1 = require("..");
const Element_1 = require("./Element");
const Group_1 = require("./Group");
class PublicCategory {
    constructor(data) {
        this.id = data.id;
        this.group = data.group;
        this.elements = data.elements;
        this.drawRequired = data.drawRequired;
        this.name = data.name;
        this.thumb = data.thumb;
        this.order = data.order;
        this.zIndex = data.zIndex;
        this.defaultElement = data.defaultElement;
        this.dependsCategoryPalette = data.dependsCategoryPalette;
        this.mappingPalette = data.mappingPalette;
    }
}
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], PublicCategory.prototype, "id", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", typeof (_a = typeof Group_1.GroupId !== "undefined" && Group_1.GroupId) === "function" ? _a : Object)
], PublicCategory.prototype, "group", void 0);
__decorate([
    class_validator_1.IsString({ each: true }),
    __metadata("design:type", Array)
], PublicCategory.prototype, "elements", void 0);
__decorate([
    class_validator_1.IsBoolean(),
    __metadata("design:type", Boolean)
], PublicCategory.prototype, "drawRequired", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], PublicCategory.prototype, "name", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], PublicCategory.prototype, "thumb", void 0);
__decorate([
    class_validator_1.IsNumber(),
    __metadata("design:type", Number)
], PublicCategory.prototype, "order", void 0);
__decorate([
    class_validator_1.IsNumber(),
    __metadata("design:type", Number)
], PublicCategory.prototype, "zIndex", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", typeof (_b = typeof __1.TransformId !== "undefined" && __1.TransformId) === "function" ? _b : Object)
], PublicCategory.prototype, "transform", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsString(),
    __metadata("design:type", typeof (_c = typeof Element_1.ElementId !== "undefined" && Element_1.ElementId) === "function" ? _c : Object)
], PublicCategory.prototype, "defaultElement", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsString(),
    __metadata("design:type", String)
], PublicCategory.prototype, "dependsCategoryPalette", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsObject(),
    __metadata("design:type", Object)
], PublicCategory.prototype, "mappingPalette", void 0);
exports.PublicCategory = PublicCategory;
// export class Category extends NetworkModel implements ICategory {
// 	id!: CategoryId
// 	@IsString()
// 	group!: string
// 	@IsString({ each: true })
// 	elements: ElementId[] = []
// 	@IsString()
// 	name!: string
// 	@IsString()
// 	thumb!: string
// 	@IsNumber()
// 	order: number = DEFAULT_ORDER
// 	@IsNumber()
// 	zIndex: number = DEFAULT_ZINDEX
// 	@IsBoolean()
// 	drawRequired: boolean = false // required for drawing defaults (es: occhi)
// 	@IsBoolean()
// 	visible: boolean = false
// 	@IsString()
// 	dependsOn?: CategoryId[]
// 	@IsObject()
// 	thumbBounding?: {
// 		scale: number
// 		x: number
// 		y: number
// 	}
// 	@IsOptional()
// 	@IsString()
// 	transform?: TransformId
// 	@IsOptional()
// 	@IsString()
// 	defaultElement?: ElementId
// 	@IsOptional()
// 	@IsString()
// 	dependsCategoryPalette?: CategoryId
// 	@IsOptional()
// 	@IsObject()
// 	mappingPalette?: MappingPalette
// }
